import { render, staticRenderFns } from "./eventForm.vue?vue&type=template&id=5bc984fd&scoped=true"
import script from "./eventForm.ts?vue&type=script&lang=ts&external"
export * from "./eventForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc984fd",
  null
  
)

export default component.exports